import React, { useState } from "react";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { RiMenuFold2Line } from "react-icons/ri";
import { MdMenuOpen } from "react-icons/md";


function PageHeader(Props) {
   const { HeaderText, backButtonUrl, buttonName, onBack, backgroundUrlName } = Props;
   const [toggleMenu, setToggleMenu] = useState(true);
   const navigate = useNavigate();
   const location = useLocation();


   const onToggleMenu = () => {
      setToggleMenu(!toggleMenu);
      if (!toggleMenu) {
         document.body.classList.remove("layout-fullwidth");
      } else {
         document.body.classList.add("layout-fullwidth");
      }
   };
   const handleBackClick = () => {
      if (onBack) {
         onBack(); // Call the onClick callback first
      }
      if (backButtonUrl) {
         navigate(backButtonUrl);
      } else {
         navigate(-1);  // This goes back to the previous page
      }
   };
   return (
      <div className="block-header" style={{ width: "99%" }}>
         <div className="row">
            <div className={location.pathname.includes('/rooms/') ? '' : 'col-lg-5 col-md-6 col-sm-12'}>
               <h6>
                  <a
                     href="#!"
                     className="btn btn-xs btn-link btn-toggle-fullwidth"
                     onClick={e => {
                        e.preventDefault();
                        onToggleMenu();
                     }}

                  >
                     {/* <i className={toggleMenu ? `fa fa-arrow-left` : "fa fa-arrow-right"}></i> */}
                     {toggleMenu ? <MdMenuOpen size={25} /> : <RiMenuFold2Line size={25} />}
                  </a>{" "}
                  {HeaderText}
               </h6>
               {/* <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                     <a href="/dashboard">
                        <i className="icon-home"></i>
                     </a>
                  </li>
                  {Breadcrumb.map((item, index) => {
                     return (
                        <li key={item.name + index} className="breadcrumb-item active">
                           <a href={item.navigate ? item.navigate : null}>{item.name}</a>
                        </li>
                     );
                  })}
               </ul> */}
            </div>
            <div className="col-lg-7 col-md-4 col-sm-12 text-right">
               {(backButtonUrl || backgroundUrlName) && (
                  <Button
                     shape="round"
                     className="me-1 border-0"
                     icon={<i className="fa fa-arrow-circle-left fa-lg" aria-hidden="true" />}
                     style={{ backgroundColor: "#6E6E6E", color: "white" }}
                     onClick={handleBackClick}
                  >
                     {buttonName ? buttonName : "Back"}
                  </Button>
               )}
            </div>
         </div>
      </div>
   );
}
export default PageHeader;
